import { useAsyncFn } from 'react-use';

import { useContextSelector } from 'use-context-selector';
import { thirdPartySignInAndUp } from 'supertokens-auth-react/recipe/thirdpartyemailpassword';

import { AuthContext } from '../../contexts/Auth.context';

export const useThirdPartySignInAndUp = () => {
  const responseErrorInterceptor = useContextSelector(
    AuthContext,
    ({ responseErrorInterceptor }) => responseErrorInterceptor
  );

  return useAsyncFn(async () => {
    try {
      const response = await thirdPartySignInAndUp();
      if (response.status === 'OK') {
        return { user: response.user, isNew: response.createdNewUser };
      }
      if (response.status === 'NO_EMAIL_GIVEN_BY_PROVIDER') {
        throw new Error(
          'No email provided by social login. Please use another form of login'
        );
      }
    } catch (error) {
      if (error instanceof Error) {
        responseErrorInterceptor(error);
      }
      throw error;
    }
  });
};
